var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"width-full height-full overflow-hidden"},[_c('HtTable',{ref:"partsListTable",attrs:{"data":_vm.tableData,"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }